var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"px-2 py-1 flex flex-row justify-end"},[_c('span',{staticClass:"font-medium"},[_vm._v(_vm._s(_vm.numeral(_vm.item.km).format('0,0')))])])}
var staticRenderFns = []

export { render, staticRenderFns }